import { Container, Typography, Grid, Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Image } from 'cloudinary-react'

const useStyles = makeStyles((theme) => ({
    bg: {
        padding: '1.5rem 0',
    },
    h1: {
        fontSize: '50px',
        fontWeight: 500,
    },
    h2: {
        fontSize: '20px',
        margin: '.6rem 0',
    },
    copy: {
        [theme.breakpoints.up('md')]: {
            width: '85%',
        },
    },
    button: {
        width: '100%',
        marginTop: '1rem',
        [theme.breakpoints.up(425)]: {
            width: '25rem',
        },
    },
    imgContainer: {
        [theme.breakpoints.down('md')]: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
    },
    img: {
        [theme.breakpoints.down('sm')]: {
            marginTop: '20px',
        },
    },
}))

const Hero = ({ h1, h2, copy, imgSrc, imgAltText }) => {
    const classes = useStyles()

    return (
        <div className={classes.bg}>
            <Container>
                <Grid container justify="center" alignItems="center">
                    <Grid item md={8}>
                        <div>
                            <Typography variant="h1" className={classes.h1}>
                                {h1}
                            </Typography>
                            <Typography variant="h2" className={classes.h2}>
                                {h2}
                            </Typography>
                            <Typography className={classes.copy}>
                                {copy}
                            </Typography>
                            <Button
                                href={
                                    'https://customerreviews.google.com/v/merchant?q=giftcardgranny.com&c=US&v=19'
                                }
                                target={'_blank'}
                                rel={'noopener noreferrer'}
                                color="primary"
                                variant="contained"
                                className={classes.button}
                            >
                                Love Gift Card Granny? Leave us a review!
                            </Button>
                        </div>
                    </Grid>
                    <Grid item md={4}>
                        <div className={classes.imgContainer}>
                            <Image
                                className={classes.img}
                                src={imgSrc}
                                alt={imgAltText}
                                width={310}
                                height={181}
                            />
                        </div>
                    </Grid>
                </Grid>
            </Container>
        </div>
    )
}

export default Hero
